<div class="d-flex flex-column w-100">
  <app-section-title3 [title]="title" color="dark"></app-section-title3>
  <div class="w-100">
    <p *ngFor="let item of items" class="item">
      <span class="elsa-title-font" *ngIf="item.key">{{item.key}}<ng-container *ngIf="item.value && item.key">:</ng-container>&nbsp;</span>{{item.value}}</p>
  </div>
  <ng-container *ngIf="img">
    <div class="d-flex justify-content-center w-100">
      <img [src]="img" [alt]="title" class="item-img">
    </div>
  </ng-container>
</div>
